import { CheckoutActions } from '../actions';
import { CustomCheckoutState } from '../checkout-state';

export const initialState: CustomCheckoutState['activeModes'] = {
  receiptType: undefined,
  pickup: undefined,
  addressId: undefined,
  timeSlotId: undefined,
  timeSlotAdditionalParams: undefined,
  serviceId: undefined,
  applyingBonus: undefined,
  contacts: undefined,
};

export function reducer(
  state = initialState,
  action:
    | CheckoutActions.CheckoutActions
    | CheckoutActions.ReceiptTypeActions
    | CheckoutActions.ApplyingBonusActions
    | CheckoutActions.SavedDeliveryAddressAction
    | CheckoutActions.PaymentModesActions
    | CheckoutActions.TimeSlotsActions
    | CheckoutActions.ServicesActions
    | CheckoutActions.ContactsActions
    | CheckoutActions.UserPickupShopsActions,
): CustomCheckoutState['activeModes'] {
  switch (action.type) {
    case CheckoutActions.CHECKOUT_DESTROY: {
      return initialState;
    }

    case CheckoutActions.SET_APPLYING_BONUS: {
      return {
        ...state,
        applyingBonus: action.payload,
      };
    }

    case CheckoutActions.RESET_APPLYING_BONUS: {
      return {
        ...state,
        applyingBonus: initialState.applyingBonus,
      };
    }

    case CheckoutActions.SET_ACTIVE_RECEIPT_TYPE: {
      return {
        ...state,
        receiptType: action.payload,
      };
    }

    case CheckoutActions.SET_SHOP: {
      return {
        ...state,
        pickup: action.payload,
      };
    }

    case CheckoutActions.REMOVE_USER_PICKUP_SHOP: {
      const shopName = action.payload.shopName;

      if (state.pickup === shopName) {
        return {
          ...state,
          pickup: initialState.pickup,
        };
      }

      return state;
    }

    case CheckoutActions.LOAD_USER_PICKUP_SHOP_LIST_FAIL:
    case CheckoutActions.LOAD_USER_PICKUP_SHOP_LIST_RESET: {
      if (state.pickup) {
        return {
          ...state,
          pickup: initialState.pickup,
        };
      }

      return state;
    }

    case CheckoutActions.SELECT_ACTIVE_DELIVERY_ADDRESS: {
      return {
        ...state,
        addressId: action.payload,
      };
    }

    case CheckoutActions.DELETE_SAVED_DELIVERY_ADDRESS: {
      const deletedId = action.payload as string;

      if (state.addressId === deletedId) {
        return {
          ...state,
          addressId: initialState.addressId,
        };
      }

      return state;
    }

    case CheckoutActions.LOAD_SAVED_DELIVERY_ADDRESS_LIST_FAILURE:
    case CheckoutActions.LOAD_SAVED_DELIVERY_ADDRESS_LIST_RESET: {
      if (state.addressId) {
        return {
          ...state,
          addressId: initialState.addressId,
        };
      }

      return state;
    }

    case CheckoutActions.SELECT_SERVICES_ACTIVE_OPTION: {
      return {
        ...state,
        serviceId: action.payload,
      };
    }

    case CheckoutActions.LOAD_SERVICES_FAIL:
    case CheckoutActions.RESET_LOADED_SERVICES: {
      if (state.serviceId) {
        return {
          ...state,
          serviceId: initialState.serviceId,
        };
      }

      return state;
    }

    case CheckoutActions.SELECT_TIME_SLOTS_ACTIVE_OPTION: {
      return {
        ...state,
        timeSlotId: action.payload,
        timeSlotAdditionalParams: action.additionalParams,
      };
    }

    case CheckoutActions.RESET_LOADED_TIME_SLOTS:
    case CheckoutActions.LOAD_TIME_SLOTS_FAIL:
    case CheckoutActions.RESET_TIME_SLOTS_ACTIVE_OPTION: {
      if (state.timeSlotId || state.timeSlotAdditionalParams) {
        return {
          ...state,
          timeSlotId: initialState.timeSlotId,
          timeSlotAdditionalParams: initialState.timeSlotAdditionalParams,
        };
      }

      return state;
    }

    case CheckoutActions.SET_CHECKOUT_CONTACTS: {
      return {
        ...state,
        contacts: action.payload,
      };
    }

    case CheckoutActions.RESET_CHECKOUT_CONTACTS: {
      return {
        ...state,
        contacts: initialState.contacts,
      };
    }

    default: {
      return state;
    }
  }
}
